var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1308_300180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 17H11C10.448 17 10 17.448 10 18C10 18.552 10.448 19 11 19H21C21.552 19 22 18.552 22 18C22 17.448 21.552 17 21 17ZM23 11H9C8.448 11 8 11.448 8 12C8 12.552 8.448 13 9 13H23C23.552 13 24 12.552 24 12C24 11.448 23.552 11 23 11ZM16 0C7.16403 0 0 6.26797 0 14C0 18.419 2.34499 22.353 6 24.919V32L13.009 27.747C13.979 27.907 14.977 28 16 28C24.837 28 32 21.732 32 14C32 6.26797 24.837 0 16 0ZM16 26C14.832 26 13.704 25.864 12.62 25.633L7.91195 28.463L7.97495 23.825C4.36601 21.654 2 18.066 2 14C2 7.37302 8.26797 2 16 2C23.732 2 30 7.37302 30 14C30 20.627 23.732 26 16 26Z",
    fill: "#0EA5E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1308_300180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.2a43018d7508cc2b93482e9ca13db2a8.svg";
export { ForwardRef as ReactComponent };